import type { ReactElement, ReactNode } from 'react';

import { mixpanelClient } from './mixpanelClient';
import { MixpanelContext } from './mixpanelContext';

export function MixpanelProvider({ children }: { children: ReactNode }): ReactElement {
    return <MixpanelContext.Provider value={mixpanelClient}>{children}</MixpanelContext.Provider>;
}
